import ConfigFile from "../../../datasets/config_file";
import { calcTaxAmt } from "../../../objects/AssetsExpenses/taxAmtCalc_function";
import createInvestTaxSummary from "./create_invest_tax_summary";

export const determineInvestTaxAmt = (gameInvestmentArr, gameDate, assetTable) => {
    const incomeAmtTaxThreshold = +ConfigFile.investments.taxThreshold;
        
    const regularTaxRate = +calcTaxAmt(assetTable, "regular", "TaxRate");
    const capitalTaxRate = +calcTaxAmt(assetTable, "capital", "TaxRate");
    const gameYear = (gameDate.split("-")[0]);
    let taxSummaryAmounts = [];
    let totalRegularIncomeAmt = 0;
    let totalCapitalIncomeAmt = 0;
    for (let i=0; i<gameInvestmentArr.length; i++){
        const investType = gameInvestmentArr[i].investType;
        let currentYearHistory = 
            gameInvestmentArr[i].historyTranArr.filter(item => item.dateClosed.split("-")[0] === gameYear );
        if (currentYearHistory.length > 0){
            const taxSummaryInvestType = createInvestTaxSummary(currentYearHistory, investType, gameYear);
            taxSummaryAmounts.push({...taxSummaryInvestType, indx: i});
            totalRegularIncomeAmt += taxSummaryInvestType.regularIncomeAmt;
            totalCapitalIncomeAmt += taxSummaryInvestType.capitalIncomeAmt;
        }
    }
    if (totalCapitalIncomeAmt < 0){
        //  the IRS allows for up to $3000 of capital losses to be applied to ordinary income.
        let taxReduceAmt = totalCapitalIncomeAmt * -1;
        if (taxReduceAmt > 3000){
             taxReduceAmt = 3000; 
        }
        totalRegularIncomeAmt -= taxReduceAmt;
    }
    let totalRegularTaxAmt = 0;
    let totalCapitalTaxAmt = 0;
    let gameInvestUpdtArr = [];
    if (totalRegularIncomeAmt >= incomeAmtTaxThreshold || totalCapitalIncomeAmt >= incomeAmtTaxThreshold){
        for (let i=0; i<taxSummaryAmounts.length; i++){
            let historyArr = [];
            const investType = taxSummaryAmounts[i].investType;
            if (taxSummaryAmounts[i].regularIncomeAmt > 0 && +regularTaxRate > 0){
                const regularTaxAmt = 
                    (taxSummaryAmounts[i].regularIncomeAmt * regularTaxRate * -1).toFixed(2);
                const incomeAmt = taxSummaryAmounts[i].regularIncomeAmt.toFixed(2);
                const taxInfo = {taxType: "regularTax", taxAmount: regularTaxAmt, taxRate: regularTaxRate,
                    incomeAmt: incomeAmt, datePaid: gameDate, taxLongText: "Federal Income Tax"}
                historyArr.push(taxInfo);
                totalRegularTaxAmt += +regularTaxAmt;
            }
            if (taxSummaryAmounts[i].capitalIncomeAmt > 0 && +capitalTaxRate > 0){ 
                const capitalTaxAmt = 
                    (taxSummaryAmounts[i].capitalIncomeAmt * capitalTaxRate * -1).toFixed(2);
                const incomeAmt = taxSummaryAmounts[i].capitalIncomeAmt.toFixed(2);
                const taxInfo = {taxType: "capitalTax", taxAmount: capitalTaxAmt, taxRate: capitalTaxRate,
                    incomeAmt: incomeAmt, datePaid: gameDate, taxLongText: "Capital Gains Tax"}
                historyArr.push(taxInfo);
                totalCapitalTaxAmt += +capitalTaxAmt;
            }
            if (historyArr.length > 0){
                const indx = gameInvestmentArr.findIndex(elem => elem.investType === investType);
                gameInvestmentArr[indx].taxHistoryArr = 
                    gameInvestmentArr[indx].taxHistoryArr.concat(historyArr);
                if (!gameInvestUpdtArr.includes(indx)){
                        gameInvestUpdtArr.push(indx);
                }
            }
        }
    }
    
    const returnObj = {regularTaxAmt: totalRegularTaxAmt, 
        capitalTaxAmt: totalCapitalTaxAmt, gameInvestmentArr: gameInvestmentArr}
    return returnObj;
}
    
export default determineInvestTaxAmt;